(function () {
  'use strict';

  var dispatchCustomEvent = function (name, data) {
    var ev = new CustomEvent(name, { detail: data || {} });
    document.dispatchEvent(ev);
  };

  function productJsonUrl(handle) {
    var base = (window.theme && theme.routes && theme.routes.root_url) || '/';
    if (base.slice(-1) !== '/') base += '/';
    return base + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function lopStlLockPageScroll() {
    if (document.body.classList.contains('lop-stl-scroll-locked')) return;
    var y = window.scrollY || window.pageYOffset || 0;
    document.body.dataset.lopStlScrollY = String(y);
    document.body.style.top = '-' + y + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.classList.add('overflow-hidden', 'lop-stl-scroll-locked');
  }

  function lopStlUnlockPageScroll() {
    if (!document.body.classList.contains('lop-stl-scroll-locked')) return;
    var y = parseInt(document.body.dataset.lopStlScrollY || '0', 10) || 0;
    document.body.classList.remove('overflow-hidden', 'lop-stl-scroll-locked');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('left');
    document.body.style.removeProperty('right');
    delete document.body.dataset.lopStlScrollY;
    window.scrollTo(0, y);
  }
  window.lopStlLockPageScroll = lopStlLockPageScroll;
  window.lopStlUnlockPageScroll = lopStlUnlockPageScroll;

  function lopStlForceOpenModal(modal) {
    if (!modal) return;
    lopStlLockPageScroll();
    modal.setAttribute('open', '');
    modal.classList.add('is-open');
    /* No usar modal.show(): mueve el foco al final del body y hace scroll hacia abajo */
  }

  window.lopStlOpenFromButton = function (btn) {
    if (!btn || !btn.getAttribute) return false;
    var sectionId = btn.getAttribute('data-lop-stl-section');
    if (!sectionId) return false;
    var slideIndex = parseInt(btn.getAttribute('data-stl-slide-index'), 10) || 0;
    if (!window.__lopStlInstances || !window.__lopStlInstances[sectionId]) {
      if (typeof window.__lopStlBoot === 'function') {
        window.__lopStlBoot(sectionId);
      }
    }
    var inst = window.__lopStlInstances && window.__lopStlInstances[sectionId];
    if (inst && typeof inst.openAt === 'function') {
      inst.openAt(slideIndex);
      return true;
    }
    var modal = document.getElementById('LopStlModal--' + sectionId);
    if (modal) {
      lopStlForceOpenModal(modal, btn);
      return true;
    }
    return false;
  };

  var stlProductJsonByHandle = Object.create(null);
  var stlProductJsonInflight = Object.create(null);
  function stlGetCachedProductJson(handle) {
    return stlProductJsonByHandle[handle] || null;
  }
  function stlEnsureProductJson(handle) {
    if (stlProductJsonByHandle[handle]) {
      return Promise.resolve(stlProductJsonByHandle[handle]);
    }
    if (stlProductJsonInflight[handle]) {
      return stlProductJsonInflight[handle];
    }
    var p = fetch(productJsonUrl(handle), { method: 'GET' })
      .then(function (r) {
        return r.json();
      })
      .then(function (pro) {
        stlProductJsonByHandle[handle] = pro;
        stlProductJsonInflight[handle] = null;
        return pro;
      })
      .catch(function (e) {
        stlProductJsonInflight[handle] = null;
        throw e;
      });
    stlProductJsonInflight[handle] = p;
    return p;
  }

  function getStlShopForRoot(stlRoot) {
    if (!stlRoot) return null;
    var sid = stlRoot.getAttribute('data-lop-section-id');
    if (!sid && stlRoot.id) {
      var m = String(stlRoot.id).match(/^LopStlModal--(.+)$/);
      if (m) sid = m[1];
    }
    if (sid) {
      var byId = document.getElementById('lop-stl-drawer--' + sid);
      if (byId) return byId;
    }
    return stlRoot.querySelector && stlRoot.querySelector('.lop-stl-js-drawer');
  }

  function stlStlListScopeForRoot(r) {
    return getStlShopForRoot(r) || r;
  }

  function stlPrefetchPanelProductRows(root) {
    if (!root || !root.hasAttribute('open')) return;
    var scope = stlStlListScopeForRoot(root);
    var panel = scope.querySelector && scope.querySelector('.lop-stl-js-panel:not([hidden])');
    if (!panel) return;
    var rows = panel.querySelectorAll('.lop-stl-row[data-product-handle]');
    for (var i = 0; i < rows.length; i++) {
      var h = rows[i].getAttribute('data-product-handle');
      if (h) stlEnsureProductJson(h).catch(function () { void 0; });
    }
  }

  function isColorOption(name) {
    if (!name) return false;
    var n = String(name).toLowerCase();
    return (
      n.indexOf('color') >= 0 ||
      n.indexOf('colour') >= 0 ||
      n === 'color' ||
      n.indexOf('colou') === 0
    );
  }
  function isSizeOption(name) {
    if (!name) return false;
    var n = String(name).toLowerCase();
    return n.indexOf('size') >= 0 || n.indexOf('talle') >= 0 || n.indexOf('talla') >= 0 || n.indexOf('tama') >= 0;
  }

  function stlOptionName(opt) {
    if (opt == null) return '';
    if (typeof opt === 'string') return opt;
    if (typeof opt === 'object') {
      if (typeof opt.name === 'string' && opt.name) return opt.name;
      if (typeof opt.label === 'string' && opt.label) return opt.label;
      if (opt.name != null) return String(opt.name);
      if (opt.label != null) return String(opt.label);
    }
    return String(opt);
  }
  function optionIndices(product) {
    var opts = product.options || [];
    var sz = -1;
    var cl = -1;
    for (var i = 0; i < opts.length; i++) {
      var on = stlOptionName(opts[i]);
      if (isSizeOption(on) && sz < 0) sz = i;
      if (isColorOption(on) && cl < 0) cl = i;
    }
    if (opts.length === 1) {
      if (sz < 0 && cl < 0) sz = 0;
    }
    if (opts.length === 2) {
      if (cl < 0) cl = 1 - (sz >= 0 ? sz : 0);
      if (sz < 0) sz = 1 - (cl >= 0 ? cl : 0);
    }
    return { size: sz, color: cl };
  }
  function stlUniqueOptionValues(product, oi) {
    var seen = {};
    var out = [];
    (product.variants || []).forEach(function (v) {
      var val = v.options[oi];
      if (val != null && !seen[val]) {
        seen[val] = true;
        out.push(val);
      }
    });
    return out;
  }
  function isLikelySizeValue(v) {
    if (v == null) return false;
    var t = String(v).trim();
    if (!t) return false;
    if (/^(xxs|xs|s|m|l|xl|xxl|xxxl|2xl|3xl|4xl|os|o\/s|u|uni)$/i.test(t)) return true;
    if (/\b(xxs|xs|s|m|l|xl|xxl|xxxl|2xl|3xl|4xl)\b/i.test(t) && t.length < 28) return true;
    if (/^(adult|adulto|niño|niña|kid)\s*[\|\/–-]\s*/i.test(t)) return true;
    if (/^[\d]{1,2}$/.test(t) && parseInt(t, 10) >= 32 && parseInt(t, 10) <= 54) return true;
    return false;
  }
  function stlScoreSizeLikeness(values) {
    if (!values.length) return 0;
    return values.filter(isLikelySizeValue).length;
  }

  function refineOptionIndices(product, idx) {
    var opts = product.options || [];
    if (opts.length !== 2) return idx;
    var u0 = stlUniqueOptionValues(product, 0);
    var u1 = stlUniqueOptionValues(product, 1);
    var s0 = stlScoreSizeLikeness(u0);
    var s1 = stlScoreSizeLikeness(u1);
    if (s0 > 0 && s1 === 0) return { size: 0, color: 1 };
    if (s1 > 0 && s0 === 0) return { size: 1, color: 0 };
    if (s0 > s1) return { size: 0, color: 1 };
    if (s1 > s0) return { size: 1, color: 0 };
    return idx;
  }
  function firstVariant(vr) {
    if (!vr || !vr.variants) return null;
    return vr.variants.find(function (v) { return v.available; }) || vr.variants[0];
  }
  function filterByColorValue(product, colorIndex, value) {
    if (colorIndex < 0 || value == null) return product.variants;
    return product.variants.filter(function (v) {
      return v.options[colorIndex] === value;
    });
  }
  function uniqueSizes(variants, sizeIndex) {
    if (sizeIndex < 0) return [];
    var seen = {};
    var out = [];
    for (var i = 0; i < variants.length; i++) {
      var s = variants[i].options[sizeIndex];
      if (s == null) continue;
      if (!seen[s]) {
        seen[s] = true;
        out.push(s);
      }
    }
    return out;
  }
  /** Talles con al menos una variante disponible en el pool (mismo criterio que PDP + is-disabled). */
  function availableSizesInPool(pool, sizeIndex, sizeValues) {
    if (sizeIndex < 0 || !sizeValues.length) return [];
    var out = [];
    for (var i = 0; i < sizeValues.length; i++) {
      var sz = sizeValues[i];
      var hasStock = pool.some(function (v) {
        return v.options[sizeIndex] === sz && v.available;
      });
      if (hasStock) out.push(sz);
    }
    return out;
  }
  function findVariantByOptions(product, selection) {
    return product.variants.find(function (v) {
      for (var k in selection) {
        if (!Object.prototype.hasOwnProperty.call(selection, k)) continue;
        if (v.options[parseInt(k, 10)] !== selection[k]) return false;
      }
      return true;
    });
  }
  function completeOptions(product, selection) {
    var base = firstVariant(product) || product.variants[0];
    if (!base) return selection;
    var out = Object.assign({}, selection);
    for (var i = 0; i < (product.options || []).length; i++) {
      if (out[i] == null) out[i] = base.options[i];
    }
    return out;
  }

  function getCartSections() {
    return [
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.LOP-cart-drawer--container' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-count' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-amount' }
    ];
  }
  function getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector || '.shopify-section')?.innerHTML;
  }
  function updateCartFromResponse(parsed) {
    if (!parsed.sections) return;
    getCartSections().forEach(function (s) {
      var el = document.getElementById(s.id);
      if (!el) return;
      var inner = getSectionInnerHTML(parsed.sections[s.section], s.selector);
      if (inner == null) return;
      var target = el.querySelector(s.selector) || el;
      target.innerHTML = inner;
    });
    if (document.getElementById('Cart-Drawer')) {
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
      } else if (typeof window.LOP !== 'undefined' && typeof window.LOP.openCartDrawer === 'function') {
        window.LOP.openCartDrawer();
      } else {
        var d = document.getElementById('Cart-Drawer');
        if (d && typeof d.open === 'function') d.open();
      }
    }
  }

  function addToCart(variantId, elBtn, onSuccess, quantity) {
    if (!window.theme || !theme.routes) return;
    if (elBtn) {
      elBtn.classList.add('loading');
      elBtn.setAttribute('aria-disabled', 'true');
    }
    var q = 1;
    if (quantity != null && !isNaN(quantity)) {
      q = Math.max(1, Math.floor(Number(quantity)));
    }
    var body = new FormData();
    body.append('id', String(variantId));
    body.append('quantity', String(q));
    body.append(
      'sections',
      getCartSections().map(function (s) {
        return s.section;
      })
    );
    body.append('sections_url', window.location.pathname);

    fetch(theme.routes.cart_add_url, {
      method: 'POST',
      body: body,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) return;
        updateCartFromResponse(data);
        dispatchCustomEvent('cart:item-added', { product: data.hasOwnProperty('items') ? data.items[0] : data });
        if (typeof onSuccess === 'function') onSuccess();
      })
      .catch(function (e) { console.error(e); })
      .finally(function () {
        if (elBtn) {
          elBtn.classList.remove('loading');
          elBtn.removeAttribute('aria-disabled');
        }
      });
  }

  function getStlPanelsScrollEl(r) {
    if (!r) return r;
    var sh = getStlShopForRoot(r);
    if (sh) {
      var p = sh.querySelector && sh.querySelector('.lop-stl-modal__panels--scroll');
      if (p) return p;
    }
    return (r.querySelector && r.querySelector('.lop-stl-modal__panels--scroll')) || r;
  }

  function closeStlRowControls(controls, expand, openBtn) {
    var row = controls && controls.closest('.lop-stl-row');
    if (row) {
      row._stlLoadTicket = (row._stlLoadTicket | 0) + 1;
    }
    if (row) row.classList.remove('is-stl-dropdown-open');
    if (expand) {
      expand.innerHTML = '';
      expand.setAttribute('hidden', '');
      expand.removeAttribute('data-stl-handle');
    }
    if (controls) {
      controls.classList.remove('is-stl-expand-open');
      controls.classList.remove('is-stl-expand-up');
    }
    if (openBtn) {
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.classList.remove('loading');
      openBtn.removeAttribute('aria-busy');
    }
  }

  function closeAllStlInlinePanels(stlRoot) {
    if (!stlRoot) return;
    var listScope = stlStlListScopeForRoot(stlRoot);
    listScope.querySelectorAll('.lop-stl-row').forEach(function (rw) {
      var ctrl = rw.querySelector('[data-lop-stl-controls]');
      var ex = rw.querySelector('[data-lop-stl-expand]');
      var ob = rw.querySelector('.lop-stl-js-open-mini');
      if (!ctrl || !ex) return;
      if (
        ctrl.classList.contains('is-stl-expand-open') ||
        (ob && ob.classList.contains('loading')) ||
        ex.getAttribute('data-stl-handle')
      ) {
        closeStlRowControls(ctrl, ex, ob);
      }
    });
  }

  function applyStlExpandDirection(controls, expand, scrollEl) {
    if (!controls || !expand) return;
    controls.classList.remove('is-stl-expand-up');
    var sp = scrollEl || document.documentElement;
    if (!sp.getBoundingClientRect) return;
    var spRect = sp.getBoundingClientRect();
    var act = controls.querySelector('.lop-stl-row__action');
    if (!act) return;
    var aRect = act.getBoundingClientRect();
    var expH = expand.offsetHeight;
    if (expH < 1) return;
    var pad = 8;
    var spaceBelow = spRect.bottom - aRect.bottom - pad;
    var spaceAbove = aRect.top - spRect.top - pad;
    if (expH > spaceBelow && spaceAbove > spaceBelow) {
      controls.classList.add('is-stl-expand-up');
    }
    requestAnimationFrame(function () {
      var r = expand.getBoundingClientRect();
      if (r.bottom > spRect.bottom - 2) {
        expand.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      } else if (r.top < spRect.top + 2) {
        expand.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    });
  }

  function mountVariantPickerBody(body, product, labels, onAddedToCart) {
    if (!body) return;
    var idx = refineOptionIndices(product, optionIndices(product));
    var first = firstVariant(product) || product.variants[0];
    if (!first) {
      body.innerHTML = '<p class="lop-stl-mini__err">Sin variantes</p>';
      return;
    }
    var cIdx = idx.color;
    var sIdx = idx.size;
    var opts = product.options || [];
    var nameColor = cIdx >= 0 ? (stlOptionName(opts[cIdx]) || labels.color) : labels.color;
    var nameSize = sIdx >= 0 ? (stlOptionName(opts[sIdx]) || labels.size) : labels.size;
    var lockedColor = cIdx >= 0 ? first.options[cIdx] : null;
    var pool = filterByColorValue(product, cIdx, lockedColor);
    if (!pool.length) pool = product.variants;
    var sizeValsAll = uniqueSizes(pool, sIdx);
    var sizeVals = availableSizesInPool(pool, sIdx, sizeValsAll);
    var sizeHtml = '';
    var selectedSize;
    if (sIdx >= 0) {
      selectedSize = sizeVals.length ? sizeVals[0] : null;
    } else {
      selectedSize = (first && first.options[0]) || '';
    }
    for (var i = 0; i < sizeVals.length; i++) {
      var sz2 = sizeVals[i];
      var selx = selectedSize && sz2 === selectedSize;
      sizeHtml += '<button type="button" class="lop-stl-picker__size' +
        (selx ? ' is-selected' : '') + '" data-size="' + escapeAttr(sz2) + '">' +
        escapeHtml(sz2) + '</button>';
    }
    var colorVal = cIdx >= 0 ? (lockedColor || first.options[cIdx]) : '';
    var colorBlock =
      cIdx >= 0 && colorVal
        ? '<p class="lop-stl-picker__color-line" data-stl-color-idx="' + cIdx + '">' +
        '<span class="lop-stl-picker__optname">' + escapeHtml(nameColor) + ': </span>' +
        '<span class="lop-stl-picker__optval">' + escapeHtml(String(colorVal)) + '</span></p>'
        : '';
    var talleBlock =
      sIdx >= 0 && sizeVals.length
        ? '<div class="lop-stl-picker__talle" data-stl-size-idx="' + sIdx + '">' +
        '<p class="lop-stl-picker__talle-label">' +
        '<span class="lop-stl-picker__optname">' + escapeHtml(nameSize) + ': </span>' +
        '<span class="lop-stl-picker__talle-current js-stl-talle-val">' + escapeHtml(String(selectedSize)) + '</span></p>' +
        '<div class="lop-stl-picker__sizes" data-sz-idx="' + sIdx + '">' + sizeHtml + '</div></div>'
        : '';
    var svgMinus =
      '<svg width="8" height="2" viewBox="0 0 8 2" fill="none" aria-hidden="true"><path d="M3.49692e-08 1.39998L0 0.599976L8 0.599976V1.39998L3.49692e-08 1.39998Z" fill="var(--color-body)"/></svg>';
    var svgPlus =
      '<svg width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden="true"><path d="M3.6 0H4.4V8H3.6V0Z" fill="var(--color-body)"/><path d="M3.49692e-08 4.4L0 3.6L8 3.6V4.4L3.49692e-08 4.4Z" fill="var(--color-body)"/></svg>';
    var laDec = escapeAttr(labels.qtyDec || 'Disminuir cantidad');
    var laInc = escapeAttr(labels.qtyInc || 'Aumentar cantidad');
    var atcRow =
      '<div class="add_to_cart_holder lop-stl-mini__atc">' +
      '<div class="quantity-inventory-row"><div class="quantity-stl-wrap">' +
      '<quantity-selector class="quantity">' +
      '<button class="minus" type="button" aria-label="' + laDec + '">' + svgMinus + '</button>' +
      '<input type="number" class="qty lop-stl-mini__qty" name="quantity" value="1" min="1" step="1" />' +
      '<button class="plus" type="button" aria-label="' + laInc + '">' + svgPlus + '</button>' +
      '</quantity-selector></div></div>' +
      '<div class="button-container">' +
      '<button type="button" class="button accent lop-stl-mini__add" data-vid=""><span class="lop-btn-text">' +
      escapeHtml(labels.miniAdd) +
      '</span></button>' +
      '</div></div>';
    var html = colorBlock + talleBlock + atcRow + '<p class="lop-stl-mini__err" hidden data-stl-err></p>';
    body.innerHTML = html;

    var selection = {};
    if (cIdx >= 0 && colorVal) selection[cIdx] = colorVal;
    if (sIdx >= 0 && selectedSize) selection[sIdx] = selectedSize;

    function stlApplyQtyForVariant(v) {
      var inp = body.querySelector('input.lop-stl-mini__qty');
      if (!inp) return;
      if (!v) return;
      var qr = v.quantity_rule || {};
      var minV = 1;
      if (qr.min != null && !isNaN(parseInt(String(qr.min), 10))) {
        minV = Math.max(1, parseInt(String(qr.min), 10));
      }
      var stepV = 1;
      if (qr.increment != null && !isNaN(parseFloat(String(qr.increment))) && parseFloat(String(qr.increment)) > 0) {
        stepV = parseFloat(String(qr.increment));
      }
      var maxV = null;
      if (qr.max != null && !isNaN(parseInt(String(qr.max), 10))) {
        maxV = parseInt(String(qr.max), 10);
      }
      if (
        v.inventory_management != null &&
        v.inventory_policy === 'deny' &&
        typeof v.inventory_quantity === 'number' &&
        v.inventory_quantity >= 0
      ) {
        if (maxV == null) maxV = v.inventory_quantity;
        else maxV = Math.min(maxV, v.inventory_quantity);
      }
      inp.setAttribute('min', String(minV));
      if (maxV != null) inp.setAttribute('max', String(maxV));
      else inp.removeAttribute('max');
      inp.setAttribute('step', String(stepV));
      var cur = parseInt(inp.value, 10);
      if (isNaN(cur) || cur < minV) cur = minV;
      if (maxV != null && cur > maxV) cur = maxV;
      inp.value = String(cur);
      var syncQs = function () {
        var qs = inp && inp.closest('quantity-selector');
        if (qs && typeof qs.validateQtyRules === 'function') qs.validateQtyRules();
      };
      syncQs();
      setTimeout(syncQs, 0);
    }

    function setVariant() {
      var v = findVariantByOptions(product, completeOptions(product, selection));
      var addB = body.querySelector('.lop-stl-mini__add');
      if (v) {
        if (addB) addB.setAttribute('data-vid', String(v.id));
        stlApplyQtyForVariant(v);
      } else {
        if (addB) addB.removeAttribute('data-vid');
      }
    }
    setVariant();

    body.querySelectorAll('.lop-stl-picker__size').forEach(function (bt) {
      bt.addEventListener('click', function () {
        if (bt.disabled) return;
        body.querySelectorAll('.lop-stl-picker__size').forEach(function (x) { x.classList.remove('is-selected'); });
        bt.classList.add('is-selected');
        var s = bt.getAttribute('data-size');
        if (sIdx >= 0) selection[sIdx] = s;
        var talleCur = body.querySelector('.js-stl-talle-val');
        if (talleCur) talleCur.textContent = s;
        setVariant();
      });
    });
    var addB = body.querySelector('.lop-stl-mini__add');
    if (addB) {
      addB.addEventListener('click', function () {
        var vid = addB.getAttribute('data-vid');
        if (vid) {
          var qInp = body.querySelector('input.lop-stl-mini__qty');
          var nq = qInp ? parseInt(qInp.value, 10) : 1;
          addToCart(vid, addB, onAddedToCart, nq);
        } else {
          var err = body.querySelector('[data-stl-err]');
          if (err) {
            err.textContent = 'Seleccioná un talle';
            err.hidden = false;
          }
        }
      });
    }
  }

  function openStlInlineVariantPicker(root, openBtn, handle, labels) {
    if (!openBtn) return;
    var row = openBtn.closest('.lop-stl-row');
    if (!row) return;
    var controls = row.querySelector('[data-lop-stl-controls]');
    var expand = row.querySelector('[data-lop-stl-expand]');
    if (!controls || !expand) return;
    if (openBtn.classList.contains('loading')) {
      if (row) row._stlLoadTicket = (row._stlLoadTicket | 0) + 1;
      openBtn.classList.remove('loading');
      openBtn.removeAttribute('aria-busy');
      expand.setAttribute('hidden', '');
      expand.removeAttribute('data-stl-handle');
      expand.innerHTML = '';
      return;
    }
    if (controls.classList.contains('is-stl-expand-open') && expand.getAttribute('data-stl-handle') === handle) {
      closeStlRowControls(controls, expand, openBtn);
      return;
    }
    closeAllStlInlinePanels(root);
    expand.setAttribute('data-stl-handle', handle);
    var scrollEl = getStlPanelsScrollEl(root);
    var applyDir = function () {
      requestAnimationFrame(function () {
        applyStlExpandDirection(controls, expand, scrollEl);
      });
    };
    var cached = stlGetCachedProductJson(handle);
    if (cached) {
      var onDoneA = function () {
        closeStlRowControls(controls, expand, openBtn);
      };
      mountVariantPickerBody(expand, cached, labels, onDoneA);
      expand.removeAttribute('hidden');
      openBtn.setAttribute('aria-expanded', 'true');
      controls.classList.add('is-stl-expand-open');
      row.classList.add('is-stl-dropdown-open');
      applyDir();
      try {
        expand.focus({ preventScroll: true });
      } catch (e) {
        void 0;
      }
      return;
    }
    var loadTicket = (row._stlLoadTicket = (row._stlLoadTicket | 0) + 1);
    expand.setAttribute('hidden', '');
    expand.innerHTML = '';
    openBtn.classList.add('loading');
    openBtn.setAttribute('aria-busy', 'true');
    stlEnsureProductJson(handle)
      .then(function (product) {
        if (row._stlLoadTicket !== loadTicket) return;
        openBtn.classList.remove('loading');
        openBtn.removeAttribute('aria-busy');
        var onDone = function () {
          closeStlRowControls(controls, expand, openBtn);
        };
        mountVariantPickerBody(expand, product, labels, onDone);
        expand.removeAttribute('hidden');
        openBtn.setAttribute('aria-expanded', 'true');
        controls.classList.add('is-stl-expand-open');
        row.classList.add('is-stl-dropdown-open');
        applyDir();
        try {
          expand.focus({ preventScroll: true });
        } catch (e) {
          void 0;
        }
      })
      .catch(function (err) {
        if (row._stlLoadTicket !== loadTicket) return;
        console.error(err);
        openBtn.classList.remove('loading');
        openBtn.removeAttribute('aria-busy');
        expand.innerHTML = '<p class="lop-stl-mini__err">Error al cargar el producto</p>';
        expand.removeAttribute('hidden');
        openBtn.setAttribute('aria-expanded', 'true');
        controls.classList.add('is-stl-expand-open');
        row.classList.add('is-stl-dropdown-open');
        applyDir();
      });
  }

  function dedupeStlModalsBySectionId(sectionId) {
    var idAttr = 'LopStlModal--' + sectionId;
    var list = document.querySelectorAll('modal-dialog.lop-stl-modal[id="' + idAttr + '"]');
    if (list.length <= 1) return;
    for (var m = 0; m < list.length - 1; m++) {
      list[m].remove();
    }
  }
  function initLopStlModal(sectionId) {

    dedupeStlModalsBySectionId(sectionId);
    var root = document.getElementById('LopStlModal--' + sectionId);
    if (!root) return;
    if (root._lopStlModalInit === sectionId) return;
    root._lopStlModalInit = sectionId;

    var track = document.getElementById('lop-stl-track--' + sectionId);
    var flkty = null;
    var flktyObserver = null;
    var pendingOpenIndex = null;

    function openModalAt(startIndex) {
      lopStlForceOpenModal(root);
      pendingOpenIndex = startIndex;
      requestAnimationFrame(function () {
        applyStlShellViewport();
        bindStlShellResize();
        ensureFlickity();
        setTimeout(function () {
          var idx = pendingOpenIndex;
          pendingOpenIndex = null;
          if (flkty) {
            var si = Math.max(0, Math.min((idx || 0) * 1, totalSlides - 1));
            flkty.select(si);
            showPanel(si);
            setNavDisabled();
          }
          if (track) {
            track.querySelectorAll('img').forEach(function (im) {
              if (im.complete) return;
              im.addEventListener('load', function onIm() {
                im.removeEventListener('load', onIm);
                scheduleStlShellViewport();
                stlScheduleFitToImage();
              });
            });
          }
          stlScheduleFitToImage();
          scheduleStlShellViewport();
          stlPrefetchPanelProductRows(root);
          requestAnimationFrame(function () {
            stlUpdateAllModalHotspotPositions();
          });
          setTimeout(function () {
            if (!root.hasAttribute('open') || !window.lazySizes || !window.lazySizes.loader) return;
            try {
              window.lazySizes.loader.checkElems();
            } catch (e) {
              void 0;
            }
            if (flkty && flkty.resize) {
              flkty.resize();
            }
            stlRunViewportSizeFix();
            stlUpdateAllModalHotspotPositions();
            stlFitAllCtaButtonsInRoot();
          }, 400);
          setTimeout(function () {
            if (!root.hasAttribute('open') || !flkty) return;
            stlRunViewportSizeFix();
            stlUpdateAllModalHotspotPositions();
            stlFitAllCtaButtonsInRoot();
          }, 150);
        }, 50);
      });
    }

    window.__lopStlInstances = window.__lopStlInstances || {};
    window.__lopStlInstances[sectionId] = { openAt: openModalAt };

    document.querySelectorAll(
      'button.lop-stl-open-main[data-lop-stl-section="' + sectionId + '"]'
    ).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openModalAt(parseInt(btn.getAttribute('data-stl-slide-index'), 10) || 0);
      });
    });

    var shell = root.querySelector('.lop-stl-modal__shell');
    if (root._stlResizeHandler) {
      window.removeEventListener('resize', root._stlResizeHandler);
      window.removeEventListener('orientationchange', root._stlResizeHandler);
      root._stlResizeHandler = null;
    }
    if (root._stlShellRaf) {
      clearTimeout(root._stlShellRaf);
      root._stlShellRaf = 0;
    }
    if (root._stlFitDebounce) {
      clearTimeout(root._stlFitDebounce);
      root._stlFitDebounce = 0;
    }
    if (root._stlDocShopRowClick) {
      document.removeEventListener('click', root._stlDocShopRowClick, true);
      root._stlDocShopRowClick = null;
    }
    var leftPane = root.querySelector('.lop-stl-js-left-pane');
    var labelEl = document.getElementById('lop-stl-labels--' + sectionId);
    var labels = { size: 'Size', color: 'Color', miniAdd: 'Add to cart', qtyDec: '', qtyInc: '' };
    if (labelEl) {
      try {
        labels = JSON.parse(labelEl.textContent);
      } catch (e) {
        /* defaults */
      }
    }

    var countCur = root.querySelector('.lop-stl-modal__count-current');
    var countTot = root.querySelector('.lop-stl-modal__count-total');
    var btnPrev = root.querySelector('.lop-stl-modal__arrow--prev');
    var btnNext = root.querySelector('.lop-stl-modal__arrow--next');
    var shop = getStlShopForRoot(root);
    var panels = shop ? shop.querySelectorAll('.lop-stl-js-panel') : root.querySelectorAll('.lop-stl-js-panel');

    function stlIsMobileStlViewport() {
      return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    }

    function stlSyncShopDrawerOpenClass() {
      if (!root || !shop) return;
      root.classList.toggle('lop-stl--shop-drawer-open', shop.classList.contains('is-open'));
    }
    function stlMoveShopDrawerToBody() {
      if (!shop || !stlIsMobileStlViewport() || shop.parentNode === document.body) return;
      shop._stlShopAnchor = { parent: shop.parentNode, next: shop.nextSibling };
      document.body.appendChild(shop);
    }
    function stlClearMobileShopDrawerSize() {
      if (!shop) return;
      shop.style.removeProperty('height');
      shop.style.removeProperty('max-height');
    }

    function stlUpdateMobileShopDrawerHeight() {
      if (!shop || !leftPane || !root || !root.hasAttribute('open')) return;
      if (!stlIsMobileStlViewport()) return;
      var vh = window.innerHeight;
      var ref =
        (leftPane.querySelector && leftPane.querySelector('.flickity-viewport')) ||
        (leftPane.querySelector && leftPane.querySelector('.lop-stl-modal__figure--ar')) ||
        leftPane;
      var r = ref.getBoundingClientRect();
      var top = Math.max(0, r.top);
      var h = Math.round(vh - top);
      var minH = Math.max(200, Math.round(vh * 0.35));
      var maxH = Math.max(minH, Math.round(vh * 0.98));
      h = Math.max(minH, Math.min(maxH, h));
      shop.style.setProperty('height', h + 'px', 'important');
      shop.style.setProperty('max-height', h + 'px', 'important');
    }
    function stlBindShopDrawerSizeListeners() {
      if (!root || root._stlShopSizeHandler) return;
      root._stlShopSizeHandler = function () {
        if (shop && shop.classList.contains('is-open') && stlIsMobileStlViewport() && root.hasAttribute('open')) {
          stlUpdateMobileShopDrawerHeight();
        }
      };
      window.addEventListener('resize', root._stlShopSizeHandler, { passive: true });
      window.addEventListener('orientationchange', root._stlShopSizeHandler, { passive: true });
      if (window.visualViewport) {
        try {
          window.visualViewport.addEventListener('resize', root._stlShopSizeHandler, { passive: true });
        } catch (e) {
          void 0;
        }
      }
    }
    function stlUnbindShopDrawerSizeListeners() {
      if (!root || !root._stlShopSizeHandler) return;
      window.removeEventListener('resize', root._stlShopSizeHandler);
      window.removeEventListener('orientationchange', root._stlShopSizeHandler);
      if (window.visualViewport) {
        try {
          window.visualViewport.removeEventListener('resize', root._stlShopSizeHandler);
        } catch (e) {
          void 0;
        }
      }
      root._stlShopSizeHandler = null;
    }
    function stlRestoreShopDrawerFromBody() {
      if (!shop || !shop._stlShopAnchor || !shop._stlShopAnchor.parent) return;
      if (shop.parentNode !== document.body) return;
      stlUnbindShopDrawerSizeListeners();
      stlClearMobileShopDrawerSize();
      var a = shop._stlShopAnchor;
      if (root && root._stlShopCloseTimer) {
        clearTimeout(root._stlShopCloseTimer);
        root._stlShopCloseTimer = 0;
      }
      if (root && root._stlShopCloseEnd) {
        shop.removeEventListener('transitionend', root._stlShopCloseEnd, false);
        root._stlShopCloseEnd = null;
      }
      try {
        if (a.next && a.next.parentNode === a.parent) {
          a.parent.insertBefore(shop, a.next);
        } else {
          a.parent.appendChild(shop);
        }
      } catch (e) {
        try {
          a.parent.appendChild(shop);
        } catch (e2) {
          void 0;
        }
      }
    }

    function stlRunShopDrawerOpenSlide() {
      if (!shop) return;
      if (root) {
        if (root._stlShopCloseTimer) {
          clearTimeout(root._stlShopCloseTimer);
          root._stlShopCloseTimer = 0;
        }
        if (root._stlShopCloseEnd) {
          shop.removeEventListener('transitionend', root._stlShopCloseEnd, false);
          root._stlShopCloseEnd = null;
        }
      }
      stlUpdateMobileShopDrawerHeight();
      stlBindShopDrawerSizeListeners();
      shop.classList.remove('is-open');
      void shop.offsetHeight;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!shop) return;
          stlUpdateMobileShopDrawerHeight();
          shop.classList.add('is-open');
          stlSyncShopDrawerOpenClass();
          if (root && root._stlShopAfterOpenHeightTimer) {
            clearTimeout(root._stlShopAfterOpenHeightTimer);
            root._stlShopAfterOpenHeightTimer = 0;
          }
          if (root) {
            root._stlShopAfterOpenHeightTimer = setTimeout(function () {
              root._stlShopAfterOpenHeightTimer = 0;
              if (shop && shop.classList.contains('is-open') && stlIsMobileStlViewport()) {
                stlUpdateMobileShopDrawerHeight();
              }
            }, 120);
          }
        });
      });
    }
    function stlCloseShopDrawerMobileAnimated() {
      if (!shop || !root) return;
      shop.classList.remove('is-open');
      stlSyncShopDrawerOpenClass();
      if (shop.parentNode !== document.body) {
        stlUnbindShopDrawerSizeListeners();
        stlClearMobileShopDrawerSize();
        return;
      }
      if (root._stlShopCloseTimer) {
        clearTimeout(root._stlShopCloseTimer);
        root._stlShopCloseTimer = 0;
      }
      if (root._stlShopCloseEnd) {
        shop.removeEventListener('transitionend', root._stlShopCloseEnd, false);
        root._stlShopCloseEnd = null;
      }
      var done = function () {
        if (root && root._stlShopCloseTimer) {
          clearTimeout(root._stlShopCloseTimer);
          root._stlShopCloseTimer = 0;
        }
        if (root && root._stlShopCloseEnd) {
          shop.removeEventListener('transitionend', root._stlShopCloseEnd, false);
          root._stlShopCloseEnd = null;
        }
        stlRestoreShopDrawerFromBody();
      };
      var onEnd = function (ev) {
        if (ev && ev.target !== shop) return;
        if (ev && ev.propertyName && String(ev.propertyName).toLowerCase().indexOf('transform') < 0) {
          return;
        }
        done();
      };
      root._stlShopCloseEnd = onEnd;
      shop.addEventListener('transitionend', onEnd, false);
      root._stlShopCloseTimer = setTimeout(done, 600);
    }
    var totalSlides = track ? (track.getAttribute('data-total-slides') || 1) * 1 : 1;
    if (countTot) countTot.textContent = totalSlides;

    if (root._stlHotspotDocClick) {
      document.removeEventListener('click', root._stlHotspotDocClick, true);
      root._stlHotspotDocClick = null;
    }
    if (root._stlHotspotMouseOver) {
      root.removeEventListener('mouseover', root._stlHotspotMouseOver);
      root._stlHotspotMouseOver = null;
    }

    function stlGetObjectFitContainRectInWrap(wrap, media) {
      if (!wrap) return null;
      var W = wrap.clientWidth;
      var H = wrap.clientHeight;
      if (W < 1 || H < 1) return null;
      if (!media) {
        return { left: 0, top: 0, width: W, height: H };
      }
      var tag = media.tagName && media.tagName.toLowerCase();
      if (tag !== 'img') {
        return { left: 0, top: 0, width: W, height: H };
      }
      var nw = media.naturalWidth;
      var nh = media.naturalHeight;
      if (!nw || !nh) return null;
      var scale = Math.min(W / nw, H / nh);
      var w = nw * scale;
      var h = nh * scale;
      return {
        left: (W - w) * 0.5,
        top: (H - h) * 0.5,
        width: w,
        height: h
      };
    }
    function stlApplyHotspotLayerRect(layer, rect) {
      if (!layer) return;
      if (!rect) {
        layer.style.left = '0';
        layer.style.top = '0';
        layer.style.width = '100%';
        layer.style.height = '100%';
        layer.style.removeProperty('right');
        layer.style.removeProperty('bottom');
        return;
      }
      layer.style.left = rect.left + 'px';
      layer.style.top = rect.top + 'px';
      layer.style.width = rect.width + 'px';
      layer.style.height = rect.height + 'px';
      layer.style.removeProperty('right');
      layer.style.removeProperty('bottom');
    }
    function stlUpdateModalHotspotLayer(figure) {
      if (!figure) return;
      var layer = figure.querySelector('.lop-stl-modal__hotspot-layer');
      if (!layer) return;
      var wrap = figure.querySelector('.lop-stl-modal__image-wrap');
      if (!wrap) return;
      var img = wrap.querySelector('img');
      if (!img) {
        stlApplyHotspotLayerRect(layer, stlGetObjectFitContainRectInWrap(wrap, null));
        return;
      }
      var r = stlGetObjectFitContainRectInWrap(wrap, img);
      if (r == null) {
        stlApplyHotspotLayerRect(layer, null);
        return;
      }
      stlApplyHotspotLayerRect(layer, r);
    }
    function stlUpdateAllModalHotspotLayers(r) {
      if (!r || !r.hasAttribute('open')) return;
      var figures = r.querySelectorAll('.lop-stl-modal__figure');
      for (var fi = 0; fi < figures.length; fi++) {
        stlUpdateModalHotspotLayer(figures[fi]);
      }
    }

    function stlUpdateHotspotCardPosition(hotspot) {
      if (typeof lopStlUpdateHotspotCardPosition === 'function') {
        lopStlUpdateHotspotCardPosition(hotspot, '.lop-stl-modal__figure');
      }
    }
    function stlUpdateAllModalHotspotPositions() {
      if (!root) return;
      stlUpdateAllModalHotspotLayers(root);
      root.querySelectorAll('.lop-stl-modal__figure .lop-hotspot').forEach(function (h) {
        stlUpdateHotspotCardPosition(h);
      });
    }
    if (track && !root._stlHotspotLayerImgLoad) {
      root._stlHotspotLayerImgLoad = function (e) {
        var t = e.target;
        if (!t || t.tagName !== 'IMG' || !root.hasAttribute('open')) return;
        if (!track.contains(t)) return;
        requestAnimationFrame(function () {
          stlUpdateAllModalHotspotPositions();
        });
      };
      track.addEventListener('load', root._stlHotspotLayerImgLoad, true);
    }

    function stlResetLeftLayout() {
      var lo = root.querySelector('.lop-stl-modal__layout');
      if (lo) lo.style.removeProperty('--stl-left-w');
      if (leftPane) {
        leftPane.style.removeProperty('width');
        leftPane.style.removeProperty('max-width');
      }
    }

    function stlUnbindStlModalViewportObservers() {
      if (root._stlModalViewportROTimer) {
        clearTimeout(root._stlModalViewportROTimer);
        root._stlModalViewportROTimer = 0;
      }
      if (root._stlModalViewportObs) {
        try {
          root._stlModalViewportObs.disconnect();
        } catch (e) {
          void 0;
        }
        root._stlModalViewportObs = null;
      }
      if (root._stlModalLazyLoaded) {
        if (track) {
          try {
            track.removeEventListener('lazyloaded', root._stlModalLazyLoaded, true);
          } catch (e) {
            void 0;
          }
        }
        root._stlModalLazyLoaded = null;
      }
    }

    function stlResetCtaButtonFonts() {
      if (!root) return;
      stlStlListScopeForRoot(root).querySelectorAll('.lop-stl-row__action .button').forEach(function (b) {
        b.style.removeProperty('font-size');
      });
    }

    var STL_CTA_FIT_MIN_PX = 7.5;
    var STL_CTA_FIT_MAX_STEP = 24;
    function stlFitAllCtaButtonsInRoot() {
      if (!root || !root.hasAttribute('open')) return;
      if (window.matchMedia('(max-width: 767px)').matches) {
        stlResetCtaButtonFonts();
        return;
      }
      var btns = stlStlListScopeForRoot(root).querySelectorAll('.lop-stl-row__action .button');
      for (var bi = 0; bi < btns.length; bi++) {
        stlFitOneCtaButton(btns[bi]);
      }
    }
    function stlFitOneCtaButton(btn) {
      if (!btn) return;
      if (window.matchMedia('(max-width: 767px)').matches) {
        btn.style.removeProperty('font-size');
        return;
      }

      var wBtn = typeof btn.getBoundingClientRect === 'function' ? btn.getBoundingClientRect().width : btn.clientWidth;
      if (wBtn < 4) {
        return;
      }
      if (btn.scrollWidth <= btn.clientWidth + 0.5) {
        return;
      }
      var f = parseFloat(window.getComputedStyle(btn).fontSize) || 12.5;
      if (isNaN(f) || f < STL_CTA_FIT_MIN_PX) f = 12.5;
      for (var step = 0; step < STL_CTA_FIT_MAX_STEP && f > STL_CTA_FIT_MIN_PX; step++) {
        f = Math.max(STL_CTA_FIT_MIN_PX, f - 0.5);
        btn.style.setProperty('font-size', f + 'px', 'important');
        if (btn.scrollWidth <= btn.clientWidth + 0.5) {
          break;
        }
      }
    }

    function clearStlShellStylesOnly() {
      stlResetLeftLayout();
      stlResetCtaButtonFonts();
      if (shell) {
        shell.classList.remove('lop-stl-modal__shell--vp');
        [
          'width',
          'max-width',
          'min-width',
          'min-height',
          'height',
          'max-height'
        ].forEach(function (p) {
          shell.style.removeProperty(p);
        });
      }
    }

    function clearStlShellViewport() {
      stlUnbindStlModalViewportObservers();
      if (root._stlResizeHandler) {
        window.removeEventListener('resize', root._stlResizeHandler);
        window.removeEventListener('orientationchange', root._stlResizeHandler);
        if (window.visualViewport) {
          try {
            window.visualViewport.removeEventListener('resize', root._stlResizeHandler);
          } catch (e) {
            void 0;
          }
        }
        root._stlResizeHandler = null;
      }
      if (root._stlFitDebounce) {
        clearTimeout(root._stlFitDebounce);
        root._stlFitDebounce = 0;
      }
      root._stlPendingResizeApply = 0;
      clearStlShellStylesOnly();
    }

    function getStlUsableInnerHeight() {
      var vv = window.visualViewport;
      if (vv && typeof vv.height === 'number' && vv.height > 0) {
        return vv.height;
      }
      return window.innerHeight;
    }
    function getStlUsableInnerWidth() {
      var vv = window.visualViewport;
      if (vv && typeof vv.width === 'number' && vv.width > 0) {
        return vv.width;
      }
      return window.innerWidth;
    }
    function computeStlShellBox() {
      var ih = getStlUsableInnerHeight();
      var iw = getStlUsableInnerWidth();
      if (ih < 1) {
        return { maxH: Math.max(1, window.innerHeight - 4), maxW: Math.min(1140, Math.max(1, window.innerWidth - 16)) };
      }
      var cap = Math.max(1, Math.floor(ih) - 8);
      var h = Math.min(Math.floor(ih * 0.92), cap);
      h = Math.max(120, h);
      if (h > cap) h = cap;
      var capW = Math.max(1, Math.floor(iw) - 16);
      var fromVw = Math.floor(iw * 0.88);

      var fromH = Math.floor(h * 1.32);
      var w = Math.min(1140, fromVw, fromH, capW);
      if (w < 1) w = 1;
      return { maxH: h, maxW: w };
    }

    function stlGetActiveSlideImage() {
      if (!track) return null;
      var cell = null;
      if (flkty) {
        if (flkty.selectedElement) {
          cell = flkty.selectedElement;
        } else if (typeof flkty.selectedIndex === 'number' && flkty.selectedIndex >= 0) {
          var sl = flkty.slider;
          if (sl && sl.children && flkty.selectedIndex < sl.children.length) {
            cell = sl.children[flkty.selectedIndex];
          } else {
            var slides = track.querySelectorAll('.carousel__slide.lop-stl-modal__cell');
            if (slides && slides[flkty.selectedIndex]) cell = slides[flkty.selectedIndex];
          }
        }
      }
      if (!cell) {
        cell = track.querySelector('.carousel__slide.is-selected') || track.querySelector('.carousel__slide.lop-stl-modal__cell');
      }
      if (!cell) return null;
      var img = cell.querySelector('.lop-stl-modal__image-wrap img');
      return img && img.tagName === 'IMG' ? img : null;
    }
    function stlEstimateLeftColumnWidthPxForAspect(box) {
      if (leftPane) {
        var rw = leftPane.getBoundingClientRect().width;
        if (rw > 2) return Math.floor(rw);
      }
      return Math.max(1, Math.floor(box.maxW * 0.55));
    }

    function stlMergeShellBoxWithImageAspect(box) {
      if (!box) return box;
      var im = stlGetActiveSlideImage();
      if (!im || !im.naturalWidth || !im.naturalHeight) return box;
      var leftW = stlEstimateLeftColumnWidthPxForAspect(box);
      if (leftW < 1) return box;
      var idealH = Math.ceil((leftW * im.naturalHeight) / im.naturalWidth);
      if (idealH < 1 || idealH >= box.maxH) return box;
      var floored = Math.max(220, idealH);
      var h = Math.min(box.maxH, floored);
      if (h >= box.maxH) return box;
      return { maxH: h, maxW: box.maxW };
    }

    function applyStlShellViewport() {
      if (!shell) return;
      if (!root.hasAttribute('open')) return;
      var fromResize = !!root._stlPendingResizeApply;
      root._stlPendingResizeApply = 0;
      if (window.matchMedia('(max-width: 767px)').matches) {
        clearStlShellStylesOnly();
        if (flkty && flkty.resize) flkty.resize();
        requestAnimationFrame(function () {
          stlUpdateAllModalHotspotPositions();
        });
        return;
      }
      var box = stlMergeShellBoxWithImageAspect(computeStlShellBox());
      shell.classList.add('lop-stl-modal__shell--vp');
      shell.style.setProperty('min-width', '0', 'important');
      shell.style.setProperty('max-width', box.maxW + 'px', 'important');
      shell.style.setProperty('max-height', box.maxH + 'px', 'important');

      shell.style.setProperty('height', box.maxH + 'px', 'important');
      shell.style.removeProperty('min-height');
      stlResetCtaButtonFonts();
      if (flkty) {

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            var b0 = computeStlShellBox();
            var bRef = stlMergeShellBoxWithImageAspect(b0);
            if (bRef.maxH < b0.maxH) {
              shell.style.setProperty('max-height', bRef.maxH + 'px', 'important');
              shell.style.setProperty('height', bRef.maxH + 'px', 'important');
            }
            stlScheduleFitToImage(fromResize);
            requestAnimationFrame(function () {
              stlFitAllCtaButtonsInRoot();
            });
          });
        });
      } else {
        requestAnimationFrame(function () {
          stlFitAllCtaButtonsInRoot();
        });
      }
    }

    function scheduleStlShellViewport() {
      if (root._stlShellRaf) clearTimeout(root._stlShellRaf);
      root._stlShellRaf = setTimeout(function () {
        root._stlShellRaf = 0;
        root._stlPendingResizeApply = 1;
        applyStlShellViewport();
      }, 100);
    }

    function bindStlShellResize() {
      if (root._stlResizeHandler) return;
      root._stlResizeHandler = function () {
        if (!root.hasAttribute('open')) return;
        scheduleStlShellViewport();
      };
      window.addEventListener('resize', root._stlResizeHandler, { passive: true });
      window.addEventListener('orientationchange', root._stlResizeHandler, { passive: true });
      if (window.visualViewport) {

        window.visualViewport.addEventListener('resize', root._stlResizeHandler, { passive: true });
      }
    }

    function setNavDisabled() {
      if (!flkty) return;
      var i = flkty.selectedIndex;
      if (btnPrev) btnPrev.disabled = i <= 0;
      if (btnNext) btnNext.disabled = i >= totalSlides - 1;
    }

    function stlSyncFlickityViewportToFigure() {
      if (!flkty || !flkty.viewport || !track || !root.hasAttribute('open')) return;
      if (window.matchMedia('(max-width: 767px)').matches) return;
      if (!shell || !shell.classList.contains('lop-stl-modal__shell--vp')) return;
      var vp = flkty.viewport;

      vp.style.removeProperty('height');
      vp.style.removeProperty('min-height');
    }

    function stlSyncImageColumnToAspect() {
      if (!leftPane || !shell || !root.hasAttribute('open')) return;
      var layoutEl = root.querySelector('.lop-stl-modal__layout');
      if (window.matchMedia('(max-width: 767px)').matches) {
        leftPane.style.removeProperty('width');
        if (layoutEl) layoutEl.style.removeProperty('--stl-left-w');
        return;
      }
      if (!shell.classList.contains('lop-stl-modal__shell--vp')) return;
      if (layoutEl) layoutEl.style.removeProperty('--stl-left-w');
      leftPane.style.removeProperty('width');
    }

    function stlRunViewportSizeFix() {
      function stlSyncViewportLayout() {
        stlSyncFlickityViewportToFigure();
        stlSyncImageColumnToAspect();
      }
      stlSyncViewportLayout();
      requestAnimationFrame(function () {
        stlSyncViewportLayout();
        requestAnimationFrame(stlSyncViewportLayout);
      });
    }

    function stlAfterViewportROResize() {
      if (!flkty || !root.hasAttribute('open')) return;
      if (window.matchMedia('(max-width: 767px)').matches) return;
      if (flkty.resize) {
        flkty.resize();
      }
      stlRunViewportSizeFix();

    }

    function stlQueueViewportROResize() {
      if (root._stlModalViewportROTimer) clearTimeout(root._stlModalViewportROTimer);
      root._stlModalViewportROTimer = setTimeout(function () {
        root._stlModalViewportROTimer = 0;
        stlAfterViewportROResize();
      }, 32);
    }

    function stlBindStlModalViewportObservers() {
      stlUnbindStlModalViewportObservers();
      if (!track || !flkty) return;
      if (window.matchMedia('(max-width: 767px)').matches) return;
      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(function () {
          stlQueueViewportROResize();
        });
        ro.observe(track);
        if (flkty.viewport) ro.observe(flkty.viewport);
        var figs = track.querySelectorAll('.lop-stl-modal__figure');
        for (var fi = 0; fi < figs.length; fi++) {
          ro.observe(figs[fi]);
        }
        if (leftPane) ro.observe(leftPane);
        root._stlModalViewportObs = ro;
      }
      root._stlModalLazyLoaded = function (ev) {
        if (!ev || !ev.target) return;
        if (!leftPane || !leftPane.contains(ev.target)) return;
        stlQueueViewportROResize();
        if (flkty && flkty.selectedElement && flkty.selectedElement.contains(ev.target) && root.hasAttribute('open')) {
          scheduleStlShellViewport();
        }
      };
      track.addEventListener('lazyloaded', root._stlModalLazyLoaded, true);
    }

    function stlBumpCarouselLayout(options) {
      if (flkty && flkty.resize) {
        flkty.resize();
      }
      stlRunViewportSizeFix();
      if (options && options.skipLazy) return;
      if (window.lazySizes && window.lazySizes.loader) {
        try {
          window.lazySizes.loader.checkElems();
        } catch (e) {
          void 0;
        }
      }
    }

    var STL_FIT_DEBOUNCE_MS = 90;
    var STL_FIT_DEBOUNCE_RESIZE_MS = 180;
    function stlScheduleFitToImage(fromResize) {
      if (root._stlFitDebounce) clearTimeout(root._stlFitDebounce);
      var ms = fromResize ? STL_FIT_DEBOUNCE_RESIZE_MS : STL_FIT_DEBOUNCE_MS;
      root._stlFitDebounce = setTimeout(function () {
        root._stlFitDebounce = 0;
        stlFitLeftColumnToImage();
        requestAnimationFrame(function () {
          stlFitAllCtaButtonsInRoot();
        });
      }, ms);
    }

    function stlFitLeftColumnToImage() {
      if (!leftPane || !shell || !track || !root.hasAttribute('open')) return;
      if (window.matchMedia('(max-width: 767px)').matches) {
        return;
      }
      if (!shell.classList.contains('lop-stl-modal__shell--vp')) return;
      stlUpdateModalImageSizes();
      requestAnimationFrame(function () {
        stlSyncImageColumnToAspect();
        try {
          stlBumpCarouselLayout({ skipLazy: true });
        } catch (e) {
          void 0;
        }
        requestAnimationFrame(function () {
          stlSyncImageColumnToAspect();
          stlUpdateAllModalHotspotPositions();
        });
      });
    }

    function stlUpdateModalImageSizes() {
      if (!leftPane || !root.hasAttribute('open')) return;
      var w = Math.max(1, Math.round(leftPane.getBoundingClientRect().width));
      var spx = w + 'px';
      var imgs = leftPane.querySelectorAll('.lop-stl-modal__image-wrap img');
      for (var i = 0; i < imgs.length; i++) {
        var im = imgs[i];
        if (im.setAttribute) {
          if (im.getAttribute('sizes') === spx) continue;
          im.setAttribute('sizes', spx);
          im.setAttribute('data-sizes', spx);
        }
      }
    }
    function showPanel(idx) {
      for (var p = 0; p < panels.length; p++) {
        if (p === idx) {
          panels[p].removeAttribute('hidden');
        } else {
          panels[p].setAttribute('hidden', '');
        }
      }
      if (countCur) countCur.textContent = String(idx + 1);
    }
    function ensureFlickity() {
      if (typeof Flickity === 'undefined' || !track) return;
      if (flkty) {
        stlBindStlModalViewportObservers();
        requestAnimationFrame(function () {
          stlBumpCarouselLayout();
          requestAnimationFrame(function () {
            stlUpdateAllModalHotspotPositions();
          });
        });
        return;
      }
      flkty = new Flickity(track, {
        cellAlign: 'left',
        contain: true,
        adaptiveHeight: false,

        setGallerySize: false,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        cellSelector: '.carousel__slide'
      });
      stlRunViewportSizeFix();
      if (flkty && flkty.resize) {
        flkty.resize();
      }
      stlRunViewportSizeFix();

      flkty.on('change', function () {
        closeAllStlInlinePanels(root);
        showPanel(flkty.selectedIndex);
        setTimeout(function () {
          stlPrefetchPanelProductRows(root);
        }, 0);
        if (root.hasAttribute('open')) {
          scheduleStlShellViewport();
        }
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            stlFitAllCtaButtonsInRoot();
          });
        });
      });
      flkty.on('select', function () {
        setNavDisabled();
        stlScheduleFitToImage();
        requestAnimationFrame(function () {
          var openOr = root.querySelectorAll('.lop-stl-modal__figure .lop-hotspot.is-open');
          for (var oi = 0; oi < openOr.length; oi++) stlUpdateHotspotCardPosition(openOr[oi]);
          stlUpdateAllModalHotspotPositions();
        });
      });
      flkty.on('settle', function () {
        if (flkty && flkty.resize) {
          flkty.resize();
        }
        stlRunViewportSizeFix();
        requestAnimationFrame(function () {
          stlUpdateAllModalHotspotPositions();
        });
      });
      stlBindStlModalViewportObservers();
      requestAnimationFrame(function () {
        stlRunViewportSizeFix();
        stlUpdateAllModalHotspotPositions();
      });
      if (flktyObserver) flktyObserver.disconnect();
    }
    function destroyFlickity() {
      stlUnbindStlModalViewportObservers();
      if (flkty) {
        flkty.destroy();
        flkty = null;
      }
    }

    var mo = new MutationObserver(function () {
      if (!root.hasAttribute('open')) {
        root.classList.remove('is-open');
        lopStlUnlockPageScroll();
        clearStlShellViewport();
        destroyFlickity();
        if (root._stlShopAfterOpenHeightTimer) {
          clearTimeout(root._stlShopAfterOpenHeightTimer);
          root._stlShopAfterOpenHeightTimer = 0;
        }
        var shopMo = getStlShopForRoot(root);
        if (shopMo) {
          shopMo.classList.remove('is-open');
        }
        stlSyncShopDrawerOpenClass();
        stlRestoreShopDrawerFromBody();
        closeAllStlInlinePanels(root);
      }
    });
    mo.observe(root, { attributes: true, attributeFilter: ['open'] });

    if (!root._lopStlNavClick) {
      root._lopStlNavClick = function (e) {
        var nextBtn = e.target.closest && e.target.closest('.lop-stl-modal__arrow--next');
        var prevBtn = e.target.closest && e.target.closest('.lop-stl-modal__arrow--prev');
        if (!nextBtn && !prevBtn) return;
        if (!root.contains(nextBtn || prevBtn)) return;
        e.preventDefault();
        if (!flkty) return;
        if (nextBtn) flkty.next();
        else flkty.previous();
      };
      root.addEventListener('click', root._lopStlNavClick);
    }

    var openDrawer = root.querySelector('.lop-stl-js-open-drawer');
    if (openDrawer && shop) {
      openDrawer.addEventListener('click', function () {
        if (stlIsMobileStlViewport()) {
          stlMoveShopDrawerToBody();
          stlRunShopDrawerOpenSlide();
        } else {
          shop.classList.add('is-open');
          stlSyncShopDrawerOpenClass();
        }
      });
    }
    root.querySelectorAll('.lop-stl-js-close-drawer').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!shop) return;
        if (stlIsMobileStlViewport() && shop.parentNode === document.body) {
          stlCloseShopDrawerMobileAnimated();
        } else {
          shop.classList.remove('is-open');
          stlSyncShopDrawerOpenClass();
          stlRestoreShopDrawerFromBody();
        }
      });
    });

    if (root._stlEsc) {
      document.removeEventListener('keydown', root._stlEsc, true);
      root._stlEsc = null;
    }
    root._stlEsc = function (e) {
      if (!root.hasAttribute('open') || e.key !== 'Escape') return;
      var escScope = stlStlListScopeForRoot(root);
      if (escScope.querySelector && !escScope.querySelector('.is-stl-expand-open')) return;
      e.stopPropagation();
      closeAllStlInlinePanels(root);
    };
    document.addEventListener('keydown', root._stlEsc, true);
    root.addEventListener(
      'pointerenter',
      function (e) {
        var rawT = e.target;
        var elT = rawT && rawT.nodeType === 1 ? rawT : rawT && rawT.parentElement;
        var b = elT && elT.closest && elT.closest('.lop-stl-js-open-mini');
        if (!b) return;
        var shopPe = getStlShopForRoot(root);
        if (!root.contains(b) && !(shopPe && shopPe.contains(b))) return;
        var h = b.getAttribute('data-product-handle');
        if (h) stlEnsureProductJson(h).catch(function () { void 0; });
      },
      true
    );
    if (root._stlExpandLayoutTimer) {
      clearTimeout(root._stlExpandLayoutTimer);
      root._stlExpandLayoutTimer = 0;
    }
    if (root._stlExpandResize) {
      window.removeEventListener('resize', root._stlExpandResize);
    }
    root._stlExpandResize = function () {
      if (!root.hasAttribute('open')) return;
      var expScope = stlStlListScopeForRoot(root);
      if (!expScope.querySelector || !expScope.querySelector('.is-stl-expand-open')) return;
      if (root._stlExpandLayoutTimer) clearTimeout(root._stlExpandLayoutTimer);
      root._stlExpandLayoutTimer = setTimeout(function () {
        root._stlExpandLayoutTimer = 0;
        var scrollEl = getStlPanelsScrollEl(root);
        expScope.querySelectorAll('.lop-stl-row__controls.is-stl-expand-open').forEach(function (ctrl) {
          var ex = ctrl.querySelector('[data-lop-stl-expand]');
          if (ex && !ex.hasAttribute('hidden') && ex.offsetHeight) {
            applyStlExpandDirection(ctrl, ex, scrollEl);
          }
        });
      }, 150);
    };
    window.addEventListener('resize', root._stlExpandResize, { passive: true });

    root._stlHotspotMouseOver = function (e) {
      if (!root.hasAttribute('open')) return;
      var hotspot = e.target.closest && e.target.closest('.lop-hotspot');
      if (!hotspot || !hotspot.closest('.lop-stl-modal__figure')) return;
      var rel = e.relatedTarget;
      if (rel && hotspot.contains(rel)) return;
      stlUpdateHotspotCardPosition(hotspot);
    };
    root.addEventListener('mouseover', root._stlHotspotMouseOver);

    root._stlHotspotDocClick = function (e) {
      if (window.innerWidth >= 768) return;
      if (!root.hasAttribute('open')) return;
      if (!root.contains(e.target)) return;
      if (e.target.closest && e.target.closest('.lop-hotspot')) return;
      var mobileHs = root.querySelectorAll('.lop-stl-modal__figure .lop-hotspot.is-open');
      for (var hdi = 0; hdi < mobileHs.length; hdi++) mobileHs[hdi].classList.remove('is-open');
    };
    document.addEventListener('click', root._stlHotspotDocClick, true);

    root._stlDocShopRowClick = function (e) {
      if (!root.hasAttribute('open')) return;
      var shopRow = getStlShopForRoot(root);
      if (!shopRow) return;
      var t = e.target;
      var el = t && t.nodeType === 1 ? t : t && t.parentElement;
      if (!el || !el.closest) return;
      var quick = el.closest('.lop-stl-js-quickadd');
      var mini = el.closest('.lop-stl-js-open-mini');
      if (quick || mini) {
        var btn = quick || mini;
        if (!shopRow.contains(btn)) return;
        e.preventDefault();
        e.stopPropagation();
        if (quick) {
          var id = quick.getAttribute('data-variant-id');
          if (id) addToCart(id, quick);
        } else {
          var h = mini.getAttribute('data-product-handle');
          if (h) openStlInlineVariantPicker(root, mini, h, labels);
        }
        return;
      }
      if (el.closest('[data-lop-stl-expand]') || el.closest('.lop-stl-row__expand')) {
        return;
      }
      if (el.closest('a[href]')) {
        return;
      }
      var pdpRow = el.closest('.lop-stl-row');
      if (!pdpRow || !shopRow.contains(pdpRow)) return;
      var pdpUrl = pdpRow.getAttribute('data-product-url');
      if (!pdpUrl) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.metaKey || e.ctrlKey) {
        window.open(pdpUrl, '_blank', 'noopener,noreferrer');
      } else {
        window.location.assign(pdpUrl);
      }
    };
    document.addEventListener('click', root._stlDocShopRowClick, true);

    root.addEventListener('click', function (e) {
      var t = e.target;
      var hts = t.closest && t.closest('.lop-hotspot');
      if (hts && hts.closest('.lop-stl-modal__figure')) {
        if (t.closest && t.closest('.lop-hotspot__card')) return;
        e.preventDefault();
        if (window.innerWidth >= 768) return;
        hts.classList.toggle('is-open');
        var hall = root.querySelectorAll('.lop-stl-modal__figure .lop-hotspot');
        for (var hxi = 0; hxi < hall.length; hxi++) {
          if (hall[hxi] !== hts) hall[hxi].classList.remove('is-open');
        }
        if (hts.classList.contains('is-open')) stlUpdateHotspotCardPosition(hts);
        return;
      }
    });

  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  function escapeAttr(s) {
    return escapeHtml(s);
  }

  function boot(id) {
    try {
      initLopStlModal(id);
    } catch (e) {
      console.error('LopStlModal', e);
    }
  }
  window.__lopStlBoot = boot;

  function runBoot() {
    document.querySelectorAll('modal-dialog.lop-stl-modal').forEach(function (el) {
      var m = el.id && el.id.match(/LopStlModal--(.+)/);
      if (m) boot(m[1]);
    });
  }
  function runBootWhenReady() {
    if (customElements.get('modal-dialog')) {
      runBoot();
      return;
    }
    customElements.whenDefined('modal-dialog').then(runBoot).catch(function () {
      runBoot();
    });
  }
  if (!document._lopStlOpenCaptureBound) {
    document._lopStlOpenCaptureBound = true;
    document.addEventListener(
      'click',
      function (e) {
        if (window.lopStlOpenFromButton) {
          var handled =
            e.target &&
            e.target.closest &&
            e.target.closest('button.lop-stl-open-main[data-lop-stl-section]');
          if (handled && window.lopStlOpenFromButton(handled)) {
            e.preventDefault();
            e.stopPropagation();
          }
        }
      },
      true
    );
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runBootWhenReady);
  } else {
    runBootWhenReady();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.querySelector && t.querySelector('modal-dialog.lop-stl-modal')) {
      t.querySelectorAll('modal-dialog.lop-stl-modal').forEach(function (el) {
        var m = el.id && el.id.match(/LopStlModal--(.+)/);
        if (m) setTimeout(function () { boot(m[1]); }, 0);
      });
    }
  });
})();
